import { api } from "../../services/api"
import { gradationDashboardApi, paymentDashboardApi, purchaseOrderDashboardApi, paymentDashboardValueApi, invoiceSummaryApi, regionalInvoiceDashboardApi, tatApi, performanceApi } from "../../services/apiVariables"
import { GetMonthYear, GetCurrentDate } from '@src/function.js'

// ==================== Action Types ====================
// Invoice Dashboard
export const DASHBOARD_LOADING = 'DASHBOARD_LOADING';
export const FETCH_INVOICE_SUMMARY_SUCCESS = 'FETCH_INVOICE_SUMMARY_SUCCESS';
export const DASHBOARD_ERROR = 'DASHBOARD_ERROR';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';

// ✅ Regional Dashboard Action Types
export const REGIONAL_DASHBOARD_LOADING = 'REGIONAL_DASHBOARD_LOADING';
export const REGIONAL_DASHBOARD_SUCCESS = 'REGIONAL_DASHBOARD_SUCCESS';
export const REGIONAL_DASHBOARD_ERROR = 'REGIONAL_DASHBOARD_ERROR';
export const CLEAR_REGIONAL_DASHBOARD_DATA = 'CLEAR_REGIONAL_DASHBOARD_DATA';

// TAT Dashboard Action Types
export const TAT_DASHBOARD_SUCCESS = 'TAT_DASHBOARD_SUCCESS';
export const PERFORMANCE_DASHBOARD_LOADING = 'PERFORMANCE_DASHBOARD_LOADING';
export const PERFORMANCE_DASHBOARD_SUCCESS = 'PERFORMANCE_DASHBOARD_SUCCESS';
export const PERFORMANCE_DASHBOARD_ERROR = 'PERFORMANCE_DASHBOARD_ERROR';

// ----------------------Gradation----------------------------
export function gradationDashboard(offset) {
  return (dispatch) => {
    dispatch({ type: 'Gradation_LOADING' })
    gradationDashboardApi.addOffset = offset
    api(gradationDashboardApi).then(response => response.json())  // convert to json
      .then(
        data => dispatch({ type: 'Gradation_SUCCESS', data }),
        error => dispatch({ type: 'Gradation_ERROR', error: error.message || 'Unexpected Error!!!' })
      )
  }
}

// ----------------------Payment----------------------------
export function paymentDashboard(offset) {
  return (dispatch) => {
    dispatch({ type: 'Payment_LOADING' })
    paymentDashboardApi.addOffset = offset
    api(paymentDashboardApi).then(response => response.json())  // convert to json
      .then(
        data => dispatch({ type: 'Payment_SUCCESS', data }),
        error => dispatch({ type: 'Payment_ERROR', error: error.message || 'Unexpected Error!!!' })
      )
  }
}

// ----------------------Payment----------------------------
export function paymentValueDashboard(offset) {
  return (dispatch) => {
    dispatch({ type: 'PaymentValue_LOADING' })
    paymentDashboardValueApi.addOffset = offset
    api(paymentDashboardValueApi).then(response => response.json())  // convert to json
      .then(
        data => dispatch({ type: 'PaymentValue_SUCCESS', data }),
        error => dispatch({ type: 'PaymentValue_ERROR', error: error.message || 'Unexpected Error!!!' })
      )
  }
}

// ----------------------Purchase Order----------------------------
export function purchaseOrderDashboard() {
  return (dispatch) => {
    dispatch({ type: 'PODashboard_LOADING' })
    // purchaseOrderDashboardApi.addOffset = offset
    api(purchaseOrderDashboardApi).then(response => response.json())  // convert to json
      .then(
        data => dispatch({ type: 'PODashboard_SUCCESS', data }),
        error => dispatch({ type: 'PODashboard_ERROR', error: error.message || 'Unexpected Error!!!' })
      )
  }
}

// ==================== Invoice Summary Dashboard ====================
export const invoiceSummaryDashboard = (params) => {
  return (dispatch) => {
    console.log('🚀 API Call Started with params:', params);
    dispatch({ type: DASHBOARD_LOADING, payload: true });

    // Build query string
    const queryParams = new URLSearchParams();

    if (params.cssId) {
      queryParams.append('cssId', params.cssId);
    }
    if (params.from) {
      queryParams.append('from', params.from);
    }
    if (params.to) {
      queryParams.append('to', params.to);
    }
    if (params.businessUnit) {
      queryParams.append('businessUnit', params.businessUnit); // ✅ Added business unit
    }

    if (params.isMonthSelected) {
      queryParams.append('isMonthSelected', params.isMonthSelected); // ✅ Added business unit
    }


    const queryString = queryParams.toString();
    invoiceSummaryApi.addParams = queryString;

    console.log('📡 Full API URL:', invoiceSummaryApi.api);

    api(invoiceSummaryApi)
      .then(res => {
        console.log('✅ API Response received:', res);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log('📊 Data parsed:', data);
        dispatch({
          type: FETCH_INVOICE_SUMMARY_SUCCESS,
          payload: data
        });
      })
      .catch((error) => {
        console.error('❌ API Error:', error);
        dispatch({
          type: DASHBOARD_ERROR,
          payload: error.message || 'Failed to fetch invoice summary'
        });
      });
  };
};

// ==================== ✅ Regional Invoice Dashboard ====================
export const regionalInvoiceDashboard = (params) => {
  return (dispatch) => {
    console.log('🚀 Regional Dashboard API Call Started with params:', params);
    dispatch({ type: REGIONAL_DASHBOARD_LOADING });

    // Build query string
    const queryParams = new URLSearchParams();

    if (params.from) {
      queryParams.append('from', params.from);
    }
    if (params.to) {
      queryParams.append('to', params.to);
    }
    if (params.isMonthSelected !== undefined) {
      queryParams.append('isMonthSelected', params.isMonthSelected);
    }

    const queryString = queryParams.toString();
    regionalInvoiceDashboardApi.addParams = queryString;

    api(regionalInvoiceDashboardApi)
      .then(res => {
        console.log('✅ Regional Dashboard Response received:', res);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log('📊 Regional Dashboard Data parsed:', data);
        // ✅ Backend returns the data directly in the structure we need
        dispatch({
          type: REGIONAL_DASHBOARD_SUCCESS,
          payload: data // Send the entire response (has businessUnits and dateRange)
        });
      })
      .catch((error) => {
        console.error('❌ Regional Dashboard API Error:', error);
        dispatch({
          type: REGIONAL_DASHBOARD_ERROR,
          payload: error.message || 'Failed to fetch regional dashboard data'
        });
      });
  };
};

export const tatDashboard = (params) => {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_LOADING,
      payload: true
    });

    const queryParams = new URLSearchParams();

    if (params.BusinessUnit) {
      queryParams.append('BusinessUnit', params.BusinessUnit);
    }
    if (params.Status) {
      queryParams.append('Status', params.Status);
    }
    if (params.From) {
      queryParams.append('From', params.From);
    }
    if (params.To) {
      queryParams.append('To', params.To);
    }
    if (params.IsMonthSelected !== undefined) {
      queryParams.append('IsMonthSelected', params.IsMonthSelected)
    }
    if (params.Region) {
      queryParams.append('Region', params.Region);
    }
    if (params.UserId) {
      queryParams.append('UserId', params.UserId);
    }

    const queryString = queryParams.toString();
    tatApi.addParams = queryString;

    api(tatApi)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((response) => {
        // extract dates
        const fromDate = response.fromDate;
        const toDate = response.toDate;

        // extract actual list
        const transformedData = response.data.map(item => ({
          businessUnit: item.businessUnit,
          ageingBucket: item.ageingBucket,
          tat: item.tat,
          status: item.status,
          east: item.east,
          north: item.north,
          south: item.south,
          west: item.west,
          grandTotal: item.grandTotal
        }));

        dispatch({
          type: TAT_DASHBOARD_SUCCESS,
          payload: { data: transformedData, fromDate, toDate }
        });
      })
      .catch((error) => {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: error.message || 'Failed to fetch TAT dashboard data'
        });
      });
  };
};

export const performanceDashboard = (params) => {
  return (dispatch) => {
    dispatch({
      type: PERFORMANCE_DASHBOARD_LOADING,
      payload: true
    });

    const { year, businessUnit, dataType } = typeof params === 'object' && params !== null ? params : { year: params };
    const queryParams = new URLSearchParams();
    if (year !== undefined && year !== null) {
      queryParams.append('year', year);
    }
    if (businessUnit) {
      queryParams.append('businessUnit', businessUnit);
    }
    if (dataType) {
      queryParams.append('dataType', dataType);
    }

    performanceApi.addParams = queryParams.toString();

    api(performanceApi)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((response) => {
        const transformedData = Array.isArray(response)
          ? response.map(item => ({
            month: item.month ?? item.Month,
            total: item.total ?? item.Total,
            withinTat: item.withinTat ?? item.WithinTat,
            missedTat: item.missedTat ?? item.MissedTat,
            score: item.score ?? item.Score,
            targetTat: item.targetTat ?? item.TargetTat,
            achievedTat: item.achievedTat ?? item.AchievedTat
          }))
          : [];

        dispatch({
          type: PERFORMANCE_DASHBOARD_SUCCESS,
          payload: transformedData
        });
      })
      .catch((error) => {
        dispatch({
          type: PERFORMANCE_DASHBOARD_ERROR,
          payload: error.message || 'Failed to fetch Performance dashboard data'
        });
      });
  };
};

// ==================== Utility Action Creators ====================
export const clearDashboardData = () => ({
  type: CLEAR_DASHBOARD_DATA
});

// ✅ Clear Regional Dashboard Data
export const clearRegionalDashboardData = () => ({
  type: CLEAR_REGIONAL_DASHBOARD_DATA
});

export const setLoading = (loading) => ({
  type: DASHBOARD_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: DASHBOARD_ERROR,
  payload: error
});

// Retry action - useful for error recovery
export const retryFetchData = (params) => (dispatch) => {
  dispatch(invoiceSummaryDashboard(params));
};

// ✅ Retry Regional Dashboard
export const retryRegionalDashboard = (params) => (dispatch) => {
  dispatch(regionalInvoiceDashboard(params));
};

// Retry TAT Dashboard
export const retryTATDashboard = (params) => (dispatch) => {
  dispatch(tatDashboard(params));
};